import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = "919876543210"; // Your number with country code
  const message = "Hi WelCome To Varanous labs,"; // Default message

  return (
    <a
     href="https://wa.me/9063488659?text=Hi%20Varanous%20Labs%20team,%20I%20would%20like%20to%20know%20more%20about%20your%20services."
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;
